import useCaptureException from "hooks/useCaputreException";

const useCaptureRpcException = (error?: Error) => useCaptureException(error);

export default useCaptureRpcException;
